import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const ImageWrapper = styled.figure`
  margin: 64px 0 58px 0;
  width: 100%;
  img {
    width: 100%;
  }

  @media (max-width: ${breakpoints.m}) {
    img {
      max-width: 100%;
      width: auto;
    }
  }
`;
